import * as React from "react";
import { SVGProps } from "react";
function SvgRemoveIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.646 6.764a.5.5 0 0 0 0-.708l-.702-.702a.5.5 0 0 0-.708 0L12 10.59 6.764 5.354a.5.5 0 0 0-.708 0l-.702.702a.5.5 0 0 0 0 .708L10.59 12l-5.236 5.236a.5.5 0 0 0 0 .708l.702.702a.5.5 0 0 0 .708 0L12 13.41l5.236 5.236a.5.5 0 0 0 .708 0l.702-.702a.5.5 0 0 0 0-.708L13.41 12l5.236-5.236Z"
        fill="#000"
      />
    </svg>
  );
}
export default SvgRemoveIcon;
